var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.342 22a4.852 4.852 0 0 0-4.851-4.852H14.509a4.852 4.852 0 0 0 0 9.703h14.982A4.851 4.851 0 0 0 34.342 22Zm1 0c0 3.231-2.62 5.85-5.851 5.85H14.509a5.851 5.851 0 1 1 0-11.702h14.982A5.852 5.852 0 0 1 35.342 22Z",
    fill: "#172664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.33 24.912c-1.672 0-2.72-1.117-2.72-2.91 0-1.797 1.048-2.918 2.72-2.918 1.668 0 2.718 1.121 2.718 2.918 0 1.793-1.05 2.91-2.718 2.91Zm0-.984c.921 0 1.511-.746 1.511-1.926 0-1.184-.59-1.934-1.511-1.934-.922 0-1.516.75-1.516 1.934 0 1.18.59 1.926 1.516 1.926ZM20.251 24.9c-.367 0-.59-.226-.59-.613v-4.492c0-.387.22-.613.59-.613h1.72c1.296 0 2.038.683 2.038 1.797 0 .703-.347 1.304-.968 1.57l.812 1.406c.098.168.125.27.125.406 0 .313-.25.54-.594.54-.281 0-.41-.102-.601-.446l-.938-1.7h-1.004v1.532c0 .387-.219.613-.59.613Zm.59-3h1.016c.594 0 .941-.34.941-.898 0-.547-.367-.898-.953-.898h-1.004V21.9ZM15.306 24.893c-.371 0-.59-.227-.59-.614v-4.484c0-.387.219-.613.59-.613h1.703c1.157 0 1.953.77 1.953 1.93 0 1.156-.824 1.929-2.011 1.929h-1.055v1.238c0 .387-.219.614-.59.614Zm.59-2.774h.797c.676 0 1.07-.36 1.07-1.004 0-.64-.39-1-1.066-1h-.801v2.004Z",
    fill: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPro);
export default __webpack_public_path__ + "static/media/icn-pro.0c8230d981c93ab2c548b1081f0ef391.svg";
export { ForwardRef as ReactComponent };